/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UsuarioObtenerPorCredencialesGet$Params {
  Accept?: string;
  email?: string;
  password?: number;
}

export function usuarioObtenerPorCredencialesGet(http: HttpClient, rootUrl: string, params?: UsuarioObtenerPorCredencialesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, usuarioObtenerPorCredencialesGet.PATH, 'get');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.query('email', params.email, {});
    rb.query('password', params.password, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

usuarioObtenerPorCredencialesGet.PATH = '/usuario/obtener-por-credenciales';
